import { call, put, takeLatest } from 'redux-saga/effects'

import { LOGIN, unstablePreventApplicationFromRendering } from '../actions'
import { actions } from '../api'
import { API_BASE, setupSession } from '../callApi'
import { getCSRFTokenFromCookie } from '../utils/getCSRFTokenFromCookie'
import { LoginActionT } from '../../types'

export function* triggerLoginSideEffects(action: LoginActionT) {
  const { token, organization } = action.payload

  yield put(
    actions.addMetaData({
      headers: {
        Authorization: token,
        'X-CSRF-TOKEN': getCSRFTokenFromCookie(),
      },

      apiBase: `${API_BASE}/${organization.key}`,
    })
  )

  // the logout method needs to be called that way to use the correct context
  yield call(setupSession, {
    token,
    organizationKey: organization.key,
  })

  yield put(unstablePreventApplicationFromRendering())
}

export default function* watchLogoutActions() {
  yield takeLatest(LOGIN, triggerLoginSideEffects)
}
